/**
 * DeleteModeActions.js
 *
 * A component that renders the delete action button with different states
 * based on the current mode and selection status.
 *
 * Key Features:
 * - Toggles between delete mode activation and confirmation
 * - Disables button when no rows are selected in delete mode
 * - Customizable button text
 * - Visual feedback through button styling
 *
 * Props:
 * @param {boolean} deleteMode - Whether delete mode is active
 * @param {Function} handleDeleteMode - Function to toggle delete mode
 * @param {Array} selectedRows - Array of selected row IDs
 * @param {Function} setDeleteConfirmOpen - Function to open delete confirmation dialog
 * @param {string} buttonText - Text to display on the button
 */

// DeleteModeActions.js
import React from "react";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteModeActions = ({
  deleteMode,
  handleDeleteMode,
  selectedRows,
  setDeleteConfirmOpen,
  buttonText = "DELETE", // Default value if not provided
}) => (
  <Button
    onClick={deleteMode ? () => setDeleteConfirmOpen(true) : handleDeleteMode}
    startIcon={<DeleteIcon />}
    variant={deleteMode ? "contained" : "outlined"}
    size="small"
    disabled={deleteMode && selectedRows.length === 0}
  >
    {buttonText}
  </Button>
);

export default DeleteModeActions;
